const tr = {
  localeCode: "tr-TR",
  common: {
    add: "Ekle",
    all: "Tümü",
    cancel: "İptal",
    confirm: "Onayla",
    delete: "Sil",
    edit: "Düzenle",
    generated: "Otomatik oluşturuldu",
    none: "Yok",
    reset: "Sıfırla",
    restore: "Geri yükle",
    save: "Kaydet",
    saveAnyway: "Yine de kaydet",
    view: "Görüntüle"
  },
  shell: {
    expenseCommandCenter: "Gider yönetim merkezi",
    installApp: "Uygulamayı yükle",
    logout: "Çıkış",
    mainNavigation: "Ana gezinme",
    personalFinance: "Kişisel finans",
    themeMode: "Tema modu",
    toggleNavigation: "Menüyü aç veya kapat"
  },
  auth: {
    backToSignIn: "Girişe dön",
    confirmPassword: "Şifreyi onayla",
    createAccount: "Hesap oluştur",
    createWorkspace: "Güvenli yerel çalışma alanı oluştur",
    email: "E-posta",
    fullName: "Ad soyad",
    password: "Şifre",
    signIn: "Giriş yap",
    signInSubtitle: "Finans çalışma alanınıza giriş yapın"
  },
  notifications: {
    accountCreated: "Hesap oluşturuldu.",
    actionFailed: "İşlem başarısız oldu.",
    backupDownloaded: "Yedek indirildi.",
    backupRestored: "Yedek geri yüklendi.",
    backupRestoreFailed: "Yedek geri yüklenemedi.",
    csvExported: "CSV dışa aktarıldı.",
    expenseAdded: "Gider eklendi.",
    expenseDeleted: "Gider silindi.",
    expenseDeleteFailed: "Gider silinemedi.",
    expenseRestored: "Gider geri yüklendi.",
    expenseRestoreFailed: "Gider geri yüklenemedi.",
    expenseSaveFailed: "Gider kaydedilemedi.",
    expenseUpdated: "Gider güncellendi.",
    expenseUpdateFailed: "Gider güncellenemedi.",
    expensesLoadFailed: "Giderler yüklenemedi.",
    expensesResetFailed: "Giderler sıfırlanamadı.",
    goalDeleted: "Hedef silindi.",
    goalDeleteFailed: "Hedef silinemedi.",
    goalReorderFailed: "Hedefler yeniden sıralanamadı.",
    goalRestored: "Hedef geri yüklendi.",
    goalRestoreFailed: "Hedef geri yüklenemedi.",
    goalSaved: "Hedef kaydedildi.",
    goalSaveFailed: "Hedef kaydedilemedi.",
    goalsLoadFailed: "Hedefler yüklenemedi.",
    goalsResetFailed: "Hedefler sıfırlanamadı.",
    goalUpdated: "Hedef güncellendi.",
    goalUpdateFailed: "Hedef güncellenemedi.",
    importEmpty: "Bu dosyada geçerli gider bulunamadı.",
    importFailed: "İçe aktarma başarısız oldu.",
    appInstalled: "LedgerFlow uygulama olarak açılmaya hazır.",
    installDismissed: "Kurulum atlandı. LedgerFlow'u daha sonra yükleyebilirsiniz.",
    jsonExported: "JSON dışa aktarıldı.",
    localDataReset: "Yerel giderler ve hedefler sıfırlandı.",
    passwordTooShort: "Şifre en az 8 karakter olmalıdır.",
    passwordsDoNotMatch: "Şifreler eşleşmiyor.",
    profileRequired: "Ad ve e-posta zorunludur.",
    profileSaved: "Profil kaydedildi.",
    profileSaveFailed: "Profil kaydedilemedi.",
    recurringExpensesAdded: (count) => `${count} tekrarlanan gider eklendi.`,
    settingsSaved: "Ayarlar kaydedildi.",
    settingsSaveFailed: "Ayarlar kaydedilemedi.",
    themeSaveFailed: "Tema ayarı kaydedilemedi.",
    undo: "GERİ AL",
    welcomeBack: "Tekrar hoş geldiniz!",
    expensesImported: (count) => `${count} gider içe aktarıldı.`
  },
  dialogs: {
    deleteExpense: {
      confirmLabel: "Sil",
      message: "Bu gider silinecek. Silme işleminden sonra 5 saniye içinde geri alabilirsiniz.",
      title: "Gider silinsin mi?"
    },
    deleteGoal: {
      confirmLabel: "Sil",
      message: "Bu hedef silinecek. Silme işleminden sonra 5 saniye içinde geri alabilirsiniz.",
      title: "Hedef silinsin mi?"
    },
    resetWorkspace: {
      confirmLabel: "Sıfırla",
      message: "Bu işlem mevcut kullanıcıya ait tüm yerel giderleri ve hedefleri siler.",
      title: "Çalışma alanı sıfırlansın mı?"
    },
    restoreBackup: {
      confirmLabel: "Geri yükle",
      message: "Bu yedek mevcut yerel giderlerinizi, hedeflerinizi ve ayarlarınızı değiştirecek.",
      title: "Yedek geri yüklensin mi?"
    },
    saveBudget: {
      confirmLabel: "Yine de kaydet",
      message: "Bütçe bu ayın harcamalarından düşük. Ayarları yine de kaydetmek istiyor musunuz?",
      title: "Bütçe kaydedilsin mi?"
    }
  },
  dashboard: {
    activeGoals: "Aktif hedefler",
    add: "Ekle",
    addExpenses: "Gider ekleyin",
    addExpense: "Gider ekle",
    addFirstExpense: "İlk gideri ekle",
    addExpensesToRenderChart: "Grafik oluşturmak için gider ekleyin.",
    barChart: "Sütun grafik",
    barsAppearAfterFirstCategory: "İlk harcama kategorisinden sonra sütunlar görünür.",
    budgetIsNotSet: "Bütçe ayarlanmadı",
    budgetProgress: "Bütçe ilerlemesi",
    budgetRemaining: (amount) => `${amount} bu ayın bütçesinde kaldı.`,
    budgetReached: "Aylık bütçe tamamen kullanıldı.",
    budgetUsed: "Kullanılan bütçe",
    categoryBudgets: "Kategori bütçeleri",
    categoriesAppear: "Giderler eklendikten sonra kategoriler görünür.",
    categoryShare: "Kategori payı",
    categoryTotals: "Kategori toplamları",
    expense: "Gider",
    financialDashboard: "Finans paneli",
    firstTransactionHint: "İlk işlemi ekleyin, panel analiz üretmeye başlasın.",
    goals: "Hedefler",
    goalsHint: "Hedefler birikimleri harcamaların yanında görünür tutar.",
    income: "Gelir",
    incomeMinusExpenses: "Gelir eksi bu ayın giderleri",
    latestOperations: "Son işlemler",
    leftAmount: (amount) => `${amount} kaldı`,
    limitsByCategory: "Kategori limitleri",
    lineChart: "Çizgi grafik",
    livePulse: "Finansal nabız",
    monthlyHistoryHint: "Aylık geçmiş zamanla oluşur.",
    monthlyIncomePlan: "Aylık gelir planı",
    monthlyLimit: (amount) => `${amount} aylık limit`,
    monthlyPlan: "Aylık plan",
    noBarsYet: "Henüz sütun yok",
    noCategoryBudgets: "Kategori bütçesi yok",
    noCategoryData: "Kategori verisi yok",
    noData: "Veri yok",
    noExpensesYet: "Henüz gider yok",
    noGoalsYet: "Henüz hedef yok",
    noTrendYet: "Henüz trend yok",
    pieChart: "Pasta grafik",
    recentActivity: "Son hareketler",
    recurringThisMonth: (count) => `${count} tekrarlanan bu ay`,
    savingsProgress: "Birikim ilerlemesi",
    savingsTargets: "Birikim hedefleri",
    savedAmount: (amount) => `${amount} birikti`,
    setBudgetHint: "Kalan parayı takip etmek için aylık bütçe belirleyin.",
    setCategoryBudgetsHint: "Limitleri izlemek için Ayarlar bölümünde kategori bütçeleri belirleyin.",
    sixMonthTrend: "Altı aylık trend",
    spendingMix: "Harcama dağılımı",
    spentAmount: (amount) => `${amount} harcandı`,
    topCategory: "En yüksek kategori",
    totalBalance: "Toplam bakiye",
    transactions: "İşlemler",
    transactionsCount: (count) => `${count} işlem`,
    valueOfLimit: (spent, limit) => `${spent} / ${limit}`,
    tuneBudget: "Bütçeyi ayarla"
  },
  expenses: {
    actions: "İşlemler",
    addExpense: "Gider ekle",
    addFirstExpense: "İlk gideri ekle",
    amountColumn: (currency) => `Tutar (${currency})`,
    category: "Kategori",
    clearFilters: "Filtreleri temizle",
    csv: "CSV",
    date: "Tarih",
    endDate: "Bitiş tarihi",
    excel: "Excel",
    expenses: "Giderler",
    import: "İçe aktar",
    json: "JSON",
    maxAmount: "Maks. tutar",
    minAmount: "Min. tutar",
    name: "Ad",
    needCleanSlate: "Temiz başlangıç mı gerekli?",
    noExpensesFound: "Gider bulunamadı",
    noExpensesYet: "Henüz gider yok",
    noMatches: "Bu filtrelerle eşleşen kayıt yok.",
    pdf: "PDF",
    periodFilters: {
      all: "Tümü",
      today: "Bugün",
      week: "Hafta",
      month: "Ay",
      year: "Yıl"
    },
    priority: "Öncelik",
    receipt: "Fiş",
    repeat: "Tekrar",
    resetAllLocalData: "Yerel verileri sıfırla",
    search: "Arama",
    searchPlaceholder: "Gider ara",
    startDate: "Başlangıç tarihi",
    tags: "Etiketler",
    transactions: "İşlemler",
    firstExpenseHint: "İlk işlemi ekleyin, LedgerFlow analiz oluşturmaya başlasın."
  },
  goals: {
    addGoal: "Hedef ekle",
    createFirstGoal: "İlk hedefi oluştur",
    daysLeft: (days) => `${days} gün kaldı`,
    delete: "Sil",
    edit: "Düzenle",
    financialTargets: "Finansal hedefler",
    goals: "Hedefler",
    noGoalsYet: "Henüz hedef yok",
    target: (date) => `Hedef: ${date}`,
    targetDatePassed: "Hedef tarihi geçti",
    emptyHint: "Bir hedef oluşturun ve günlük harcamaların yanında ilerlemeyi takip edin."
  },
  reports: {
    addExpensesForReport: "Raporu doldurmak için gider ekleyin.",
    breakdown: "Dağılım",
    categories: "Kategoriler",
    comparison: "Karşılaştırma",
    largestSpendAreas: "En büyük harcama alanları",
    monthTotals: "Aylık toplamlar",
    monthlyReadout: "Aylık özet",
    monthlyTotalsHint: "Aylık toplamlar zamanla oluşur.",
    noCategoriesYet: "Henüz kategori yok",
    noMonthlyTotalsYet: "Henüz aylık toplam yok",
    noPriorityDataYet: "Henüz öncelik verisi yok",
    prioritiesHint: "Öncelikler giderler eklendikten sonra görünür.",
    priorityPressure: "Öncelik baskısı",
    reports: "Raporlar"
  },
  settings: {
    accentColor: "Vurgu rengi",
    appearance: "Görünüm",
    backupAndRestore: "Yedekleme ve geri yükleme",
    budgetAndIncome: "Bütçe ve gelir",
    budgetsAndOrder: "Bütçeler ve sıra",
    categoryLimits: "Kategori limitleri",
    currencies: "Para birimleri",
    dangerZone: "Tehlikeli alan",
    data: "Veriler",
    displayCurrency: "Görüntüleme para birimi",
    downloadBackup: "Yedeği indir",
    dragCategories: "Sırayı değiştirmek için kategorileri sürükleyin",
    editableExchangeRates: "Düzenlenebilir döviz kurları",
    fontSize: "Yazı boyutu",
    language: "Dil",
    localeAndDisplay: "Dil ve görünüm",
    monthlyBudget: "Aylık bütçe",
    monthlyIncome: "Aylık gelir",
    plan: "Plan",
    preferences: "Tercihler",
    ratePerUsd: (currency) => `1 USD başına ${currency}`,
    ratesHint: "Kurlar yerel olarak saklanır ve her gideri görüntüleme para biriminize çevirmek için kullanılır.",
    resetLocalData: "Yerel verileri sıfırla",
    resetWorkspace: "Çalışma alanını sıfırla",
    restoreBackup: "Yedeği geri yükle",
    saveSettings: "Ayarları kaydet",
    settings: "Ayarlar",
    theme: "Tema",
    workspaceControls: "Çalışma alanı kontrolleri",
    dangerHint: "Bu işlem oturum açmış kullanıcıya ait tüm yerel giderleri ve hedefleri siler."
  },
  profile: {
    accountIdentity: "Hesap kimliği",
    details: "Detaylar",
    email: "E-posta",
    firstSession: "İlk oturum",
    lastLogin: "Son giriş",
    name: "Ad",
    personalInformation: "Kişisel bilgiler",
    profile: "Profil",
    saveProfile: "Profili kaydet",
    uploadAvatar: "Avatar yükle",
    yourProfile: "Profiliniz"
  },
  expenseForm: {
    addTitleAndAmount: "Bir başlık ve pozitif tutar ekleyin.",
    amount: (currency) => `Tutar (${currency})`,
    cancel: "İptal",
    category: "Kategori",
    date: "Tarih",
    description: "Açıklama",
    editExpense: "Gideri düzenle",
    name: "Ad",
    namePlaceholder: "Market, kira, abonelik...",
    newExpense: "Yeni gider",
    optionalNote: "İsteğe bağlı not",
    priority: "Öncelik",
    receipt: "Fiş",
    receiptTooLarge: "Yerel yedekleme için fiş 2 MB'den küçük olmalıdır.",
    removeReceipt: (name) => `${name} kaldır`,
    repeat: "Tekrar",
    save: "Kaydet",
    tags: "Etiketler"
  },
  goalForm: {
    addTitleAndTarget: "Bir başlık ve pozitif hedef tutar ekleyin.",
    cancel: "İptal",
    currentProgress: "Mevcut ilerleme",
    description: "Açıklama",
    editGoal: "Hedefi düzenle",
    goalTitle: "Hedef başlığı",
    goalPlaceholder: "Tatil, yeni laptop, acil durum fonu",
    newGoal: "Yeni hedef",
    save: "Kaydet",
    targetAmount: "Hedef tutar",
    targetDate: "Hedef tarihi",
    whyItMatters: "Bu hedef neden önemli"
  },
  insights: {
    addExpensesPatterns: "Desenleri görmek için gider ekleyin.",
    budgetAlertsHint: "Bütçe uyarılarını açmak için aylık bütçe belirleyin.",
    budgetHealth: "Bütçe sağlığı",
    categoryAlerts: "Kategori uyarıları",
    categoryBudgetOk: "Kategori bütçeleri şu anda kontrol altında.",
    leftInBudget: (amount) => `${amount} aylık bütçede kaldı.`,
    monthlyPace: "Aylık tempo",
    newBaseline: "Yeni başlangıç",
    newBaselineDetail: "Bu ay karşılaştırma noktası olacak.",
    noData: "Veri yok",
    notSet: "Ayarlanmadı",
    overBudget: (categories) => `${categories} bütçeyi aştı.`,
    recurringDetail: "Bu ay otomatik oluşturulan ve tekrarlanan giderler.",
    recurringLoad: "Tekrarlanan yük",
    spendingAbove: "Harcamalar geçen ayın üzerinde.",
    spendingBelow: "Harcamalar geçen ayın altında.",
    spentThisMonth: (amount) => `${amount} bu ay harcandı.`,
    topCategory: "En yüksek kategori"
  },
  onboarding: {
    budgets: "Bütçenizi kontrol edin",
    getStarted: "Başlayın",
    goals: "Finansal hedeflerinize ulaşın",
    intro: "Giderlerinizi, bütçenizi ve finansal hedeflerinizi tek bir uygulamada yönetin.",
    title: "LedgerFlow'a hoş geldiniz",
    track: "Gelir ve giderlerinizi takip edin"
  },
  options: {
    menu: {
      dashboard: "Panel",
      expenses: "Giderler",
      goals: "Hedefler",
      reports: "Raporlar",
      profile: "Profil",
      settings: "Ayarlar"
    },
    categories: {
      "Food & Dining": "Yemek ve kafe",
      Transportation: "Ulaşım",
      Housing: "Konut",
      Shopping: "Alışveriş",
      Entertainment: "Eğlence",
      Healthcare: "Sağlık",
      Other: "Diğer"
    },
    priorities: {
      Low: "Düşük",
      Medium: "Orta",
      High: "Yüksek",
      Critical: "Kritik"
    },
    frequencies: {
      "One-time": "Tek seferlik",
      Daily: "Günlük",
      Weekly: "Haftalık",
      Monthly: "Aylık",
      Yearly: "Yıllık"
    },
    tags: {
      Essential: "Zorunlu",
      Business: "İş",
      Personal: "Kişisel",
      Family: "Aile",
      Travel: "Seyahat",
      Subscription: "Abonelik",
      Optional: "Opsiyonel"
    },
    themeModes: {
      auto: "Otomatik",
      light: "Açık",
      dark: "Koyu"
    },
    fontSizes: {
      compact: "Kompakt",
      comfortable: "Rahat",
      large: "Büyük"
    },
    languages: {
      EN: "İngilizce",
      RU: "Rusça",
      TR: "Türkçe"
    },
    accentThemes: {
      "#2563eb": "Mavi",
      "#0f766e": "Turkuaz",
      "#0f8a5f": "Zümrüt",
      "#b7791f": "Kehribar",
      "#be123c": "Pembe"
    }
  }
};

export default tr;
